
export function adminError (state, payload){
    state.error = true
    state.errorMessage = payload.response.data.msg
    state.isOK = false
}

export function setIsOk(state,payload){
    state.isOk = payload
}

export function setUsers(state, payload){
    state.users = payload.data
    state.error = false
}
export function setUser(state, payload){
    state.user = payload
}


export function setVendedores(state,payload){
    state.vendedores = payload.data
    state.error = false
}
export function setSolicitantes(state,payload){
    payload.data.solicitantes.forEach(element => {
        state.solicitantes.push(element.nombre)    
    });
    //state.solicitantes = payload.data.solicitantes.nombre
    state.error = false
}
